/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FieldMappingData } from './FieldMappingData';
import {
    FieldMappingDataFromJSON,
    FieldMappingDataFromJSONTyped,
    FieldMappingDataToJSON,
} from './FieldMappingData';

/**
 * 
 * @export
 * @interface ListFieldMappingsResponse
 */
export interface ListFieldMappingsResponse {
    /**
     * 
     * @type {Array<FieldMappingData>}
     * @memberof ListFieldMappingsResponse
     */
    mappings: Array<FieldMappingData>;
}

/**
 * Check if a given object implements the ListFieldMappingsResponse interface.
 */
export function instanceOfListFieldMappingsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mappings" in value;

    return isInstance;
}

export function ListFieldMappingsResponseFromJSON(json: any): ListFieldMappingsResponse {
    return ListFieldMappingsResponseFromJSONTyped(json, false);
}

export function ListFieldMappingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListFieldMappingsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mappings': ((json['mappings'] as Array<any>).map(FieldMappingDataFromJSON)),
    };
}

export function ListFieldMappingsResponseToJSON(value?: ListFieldMappingsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mappings': ((value.mappings as Array<any>).map(FieldMappingDataToJSON)),
    };
}

